import React from "react";
import { cn } from "../../lib/utils";
import { Label } from "../ui/label";

export function FormField({
  label,
  htmlFor,
  children,
  description,
  error,
  required = false,
  className,
}) {
  return (
    <div className={cn("space-y-2", className)}>
      {label ? (
        <Label htmlFor={htmlFor} className="text-[#9CA3AF]">
          {label}
          {required ? <span className="text-red-400"> *</span> : null}
        </Label>
      ) : null}
      {children}
      {description ? <p className="text-xs text-[#9CA3AF]">{description}</p> : null}
      {error ? <p className="text-xs text-red-400">{error}</p> : null}
    </div>
  );
}

export function FormGrid({ children, className, columns = 2 }) {
  const gridClass = columns === 1 ? "grid-cols-1" : "grid-cols-1 sm:grid-cols-2";

  return <div className={cn("grid gap-4", gridClass, className)}>{children}</div>;
}

export default FormField;
